import { BookingFlowType } from '../enums/booking-flow-type.enum';

export function deliveredVerbForBookingFlowType(bookingFlowType: BookingFlowType): string {
  return bookingFlowType === BookingFlowType.INVENTORY ? 'Allocated' : 'Delivered';
}
